import { actor } from '../base';
import type { UserWalletKind } from 'dfx/edge/edge.did';

export const unpairWallet = (wallet: UserWalletKind) => {
  return actor()
    .unpair_wallet(wallet)
    .then((res) => res);
};
